<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-col cols="12" md="12">
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row justify="center">

                            <v-col cols="12" md="6">
                                <p class="text-center text-muted">
                                <h5 class="text-center text-muted"><strong>¡Bienvenido!</strong>, por favor ayúdanos
                                    seleccionando el motivo por el cual has ingresado, te recuerdo que una vez
                                    seleccionado ya no podrás revertirlo.</h5>
                                <h6 class="text text-center"><strong>Recuerda siempre registrar tu entrada a
                                        trabajar</strong></h6>

                                </p>
                                <br />
                                <v-list two-line>
                                    <v-list-item-group v-model="selected" active-class="primary" multiple>
                                        <template v-for="(item, index) in items">
                                            <v-subheader v-if="item.header" :key="item.header"
                                                v-text="item.header"></v-subheader>

                                            <v-divider v-else-if="item.divider" :key="index"
                                                :inset="item.inset"></v-divider>

                                            <v-list-item v-else :id="item.tipo" :key="item.title"
                                                @click="Registrar(item)" :disabled="item.disable">
                                                <template v-slot:default="{ active }">
                                                    <v-list-item-avatar>
                                                        <v-icon :class="item.color" dark v-text="item.avatar">
                                                        </v-icon>
                                                    </v-list-item-avatar>

                                                    <v-list-item-content>
                                                        <v-list-item-title v-html="item.title"></v-list-item-title>
                                                        <v-list-item-subtitle
                                                            v-html="item.subtitle"></v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <v-btn icon>
                                                            <v-icon color="grey lighten-1">{{ item.marcado }}</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                </template>
                                            </v-list-item>
                                        </template>
                                    </v-list-item-group>
                                </v-list>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Asistencia from "@/services/Asistencia/Asistencia.service.js";

export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            showcargando: true,
            selected: [],
            items: [
                {
                    color: 'success',
                    avatar: 'mdi-import',
                    title: 'Entrada a trabajar',
                    subtitle: `Seleccioname si apenas vas a ingresar a trabajar.`,
                    marcado: 'mdi-lock-open-variant-outline',
                    tipo: 'ET',
                    disable: false,
                    msg: 'entrada laboral.'
                },
                { divider: true, inset: true },
                {
                    color: 'success',
                    avatar: 'mdi-coffee-outline',
                    title: 'Salir a comer',
                    subtitle: `Seleccioname si apenas saldrás a comer.`,
                    marcado: 'mdi-lock-open-variant-outline',
                    tipo: 'SC',
                    disable: false,
                    msg: 'salida a comer.'
                },
                { divider: true, inset: true },
                {
                    color: 'error',
                    avatar: 'mdi-office-building-outline',
                    title: 'Regresar de la comida',
                    subtitle: 'Seleccioname si ya regresaste de comer.',
                    marcado: 'mdi-lock-open-variant-outline',
                    tipo: 'EC',
                    disable: false,
                    msg: 'regresaste de comer.'
                },
                { divider: true, inset: true },
                {
                    color: 'error',
                    avatar: 'mdi-export',
                    title: 'Salir de trabajar',
                    subtitle: 'Seleccioname si ya termino tu jornada laboral.',
                    marcado: 'mdi-lock-open-variant-outline',
                    tipo: 'ST',
                    disable: false,
                    msg: 'salida laboral.'
                },
            ],
            ubicacion: '',
        }
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    methods: {
        async Registrar(item) {
            let valid = true;//this.verificar(item.tipo);
            if (valid) {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Enviando Asistencia",
                    html: "Dale en enviar, para registrar la <strong>" + item.msg + "</strong>",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Enviar',
                    cancelButtonText: 'Cancelar',
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$swal.showLoading();
                        var formData = new FormData();
                        formData.append("accion", item.tipo);
                        formData.append("ubicacion", this.ubicacion);
                        Asistencia.registrarAsistencia(formData).then(data => {
                            if (data.success == true) {
                                this.ObtenerAsistencia();
                                this.$swal({
                                    position: "center",
                                    title: "Éxito!",
                                    icon: "success",
                                    text: "Se registró correctamente la asistencia",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    timer: 4000,
                                });
                                switch (item.tipo) {
                                    case 'ET':
                                        this.items[0].marcado = 'mdi-lock-open-outline';
                                        this.items[0].disable = true;
                                        break
                                    case 'SC':
                                        this.items[2].marcado = 'mdi-lock-open-outline';
                                        this.items[2].disable = true;
                                        break;
                                    case 'EC':
                                        this.items[4].marcado = 'mdi-lock-open-outline';
                                        this.items[4].disable = true;
                                        break;
                                    case 'ST':
                                        this.items[6].marcado = 'mdi-lock-open-outline';
                                        this.items[6].disable = true;
                                        break;
                                }
                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    text: "Ocurrió un error, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                });
                            }
                        });
                    }
                    else {
                        this.ObtenerAsistencia();
                    }
                });
            }
            else {
                let list = document.getElementById(item.tipo).classList;
                document.getElementById(item.tipo).classList.remove('v-list-item--active');
                this.ObtenerAsistencia();
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Registro",
                    text: "No se puede registrar, tiene que verificarlo",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: true,
                    //timer: 2000,
                });
            }
        },
        verificar(tipo) {
            if (tipo == 'ET')
                return true;
            else if (tipo == 'SC' && this.selected.length == 1)
                return true
            else if (tipo == 'EC' && this.selected.length == 2)
                return true
            else if (tipo == 'ST' && this.selected.length == 3)
                return true
            else
                return false;
        },
        async ObtenerAsistencia() {
            await Asistencia.EstadoAsistencia().then(async data => {
                this.selected = [];
                let res = await MetodosGenerales.obtenerFechaHoraBase();
                if (data.registro == res.today) {
                    if (data.entradaTrabajo != null) {
                        this.selected.push(0);
                        this.items[0].marcado = 'mdi-lock-open-outline';
                        this.items[0].disable = true;
                    }
                    if (data.salidaComida != null) {
                        this.selected.push(1);
                        this.items[2].marcado = 'mdi-lock-open-outline';
                        this.items[2].disable = true;
                    }
                    if (data.entradaComida != null) {
                        this.selected.push(2);
                        this.items[4].marcado = 'mdi-lock-open-outline';
                        this.items[4].disable = true;
                    }
                    if (data.salidaTrabajo != null) {
                        this.selected.push(3);
                        this.items[6].marcado = 'mdi-lock-open-outline';
                        this.items[6].disable = true;
                    }
                }

            });
        },
        //Funcion para obtener latitud y longitud
        mostrarUbicacion(position) {
            var latitud = position.coords.latitude; //Obtener latitud
            var longitud = position.coords.longitude; //Obtener longitud
            this.ubicacion = latitud + ',' + longitud;
        },
        error() {

        }
    },

    async mounted() {
        if (navigator.geolocation) { //Validar si hay acceso web a la ubicación
            navigator.geolocation.getCurrentPosition(this.mostrarUbicacion, this.error, {
                enableHighAccuracy: false,
                timeout: 10000,
                maximumAge: 1000
            }); //Obtiene la posición
        } else {
            alert("¡Error! Este navegador no soporta la Geolocalización.");
        }


        this.ObtenerAsistencia();
        this.showcargando = false;
    },
}
</script>